import { createApp } from 'vue'
import App from './App.vue'
import { detectLegacySupport } from '@/utils/legacySupport'

import '@/assets/styles/main.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'

// Rileva le funzionalita' mancanti e marca l'<html> PRIMA del mount, cosi' il
// primo disegno ha gia' le classi giuste. Sui browser moderni non aggiunge
// nessuna classe: vedi src/utils/legacySupport.js
detectLegacySupport()

createApp(App).mount('#app')
